export default __webpack_public_path__ + "static/media/bootstrap-logo.6773dea1.png";